import { createAction, props } from '@ngrx/store';
import { ProvinceDto } from 'src/app/api/models';

export const loadProvinces = createAction(
  '[Province] Load Provinces'
);

export const loadProvincesSuccess = createAction(
  '[Province] Load Provinces Success',
  props<{ data: ProvinceDto[] }>()
);

export const loadProvincesFailure = createAction(
  '[Province] Load Provinces Failure',
  props<{ error: any }>()
);

export const resetProvince = createAction("[Province] Reset");